import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
} from '@angular/core';
import { ButtonToggleOption } from '../../types';

@Component({
  selector: 'ui-button-toggle-group',
  imports: [],
  templateUrl: './button-toggle-group.component.html',
  styleUrl: './button-toggle-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonToggleGroupComponent {
  options = input.required<ButtonToggleOption[]>();
  value = model.required<string>();
  size = input<'sm' | 'md'>('md');
  fullWidth = input<boolean>(true);

  protected select(option: ButtonToggleOption): void {
    if (this.value() === option.value) {
      return;
    }
    this.value.set(option.value);
  }
}
